import { LuCkeditorOptions } from '../../lu-ckeditor.models';

export const loadPlugins = (options: LuCkeditorOptions): string => {
	let extraPlugins = [];
	if (options.addMathJax) {
		extraPlugins = [...extraPlugins, 'mathjax'];
	}

	if (options.addInsertSymbols) {
		extraPlugins = [...extraPlugins, 'symbol'];
	}

	if (options.addBlankPlaceholder) {
		extraPlugins = [...extraPlugins, 'addblankquestionplaceholder'];
	}

	if (options.addEmbeddedMedia) {
		extraPlugins = [...extraPlugins, 'mediaembed'];
	}

	if (options?.plugins?.length) {
		extraPlugins = [...extraPlugins, ...options.plugins];
	}

	return extraPlugins.length ? extraPlugins.join(',') : '';
};
